import { Routes } from '@angular/router';
import { authGuard } from 'projects/visa-platform/src/app/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('projects/visa-platform/src/app/pages/home/home.component').then(
        (m) => m.HomeComponent
      ),
  },
  {
    path: 'offers',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/offer-listing/offer-listing.component'
      ).then((m) => m.OfferListingComponent),
  },
  {
    path: 'offers/checkout-message/:id',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/booking-confirmation/booking-confirmation.component'
      ).then((m) => m.BookingConfirmationComponent),
  },
  {
    path: 'offer-details/:id',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/offer-details/offer-details.component'
      ).then((m) => m.OfferDetailsComponent),
  },
  {
    path: 'info/terms-and-conditions',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/terms-and-conditions/terms-and-conditions.component'
      ).then((m) => m.TermsAndConditionsComponent),
  },
  {
    path: 'info/privacy-policy',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/privacy-policy/privacy-policy.component'
      ).then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'order-history',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/order-history/order-history.component'
      ).then((m) => m.OrderHistoryComponent),
    canActivate: [authGuard],
  },
  {
    path: 'order-history/bookings/:id',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/booking-history-details/booking-history-details.component'
      ).then((m) => m.BookingHistoryDetailsComponent),
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
